import BREAKPOINTS from '@lib/constants/breakpoints';
import { RichText, RichTextBlock } from 'prismic-reactjs';
import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  .block-quotation {
    margin-bottom: 2rem;
    display: inline-block;
    font-style: italic;
    font-size: 24px;
    text-align: center;

    @media screen and (min-width: ${BREAKPOINTS.medium}) {
      font-size: 42px;
      margin: 0 0 4rem;
    }

    @media screen and (min-width: 1200px) {
      margin: 0 -10rem 4rem;
    }
  }

  .block-quotation:before {
    content: '"';
  }

  .block-quotation:after {
    content: '"';
  }
`;

const Quote = ({
  slice,
}: {
  slice: { primary: { quote: RichTextBlock[] } };
}) => (
  <Container className="post-part single container">
    <blockquote className="block-quotation">
      {RichText.asText(slice.primary.quote)}
    </blockquote>
  </Container>
);

export default Quote;
